import ProgressReportListView from './component';
import _routes from './routes';

export const routes = _routes;
export default ProgressReportListView;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/ProgressReportListView/index.js